import { AnyAction } from "@reduxjs/toolkit";
import {
    SET_VIEWER_DATA,
    USER_LOGIN_FAILED,
    USER_LOGIN_START,
    USER_LOGIN_SUCCESS,
    USER_LOGOUT,
    USER_LOGOUT_EXPIRED,
} from "@/Redux/User/Constants";
import moment from "moment/moment";
import { RootStateOrAny } from "react-redux";

export type UserState = typeof initialState;

/*interface UserState {
    isLoggingIn: boolean,
    isLoggedIn: boolean,
    loginIsFailed: boolean,
    token: string | null | undefined,
    viewer: object | null,
    logoutIsExpired: boolean
}*/

const initialState = {
    isLoggingIn: false,
    isLoggedIn: !!localStorage.getItem("CRENT_WEB/TOKEN"),
    token: localStorage.getItem("CRENT_WEB/TOKEN") || null,
    viewer: null,
    loginIsFailed: false,
    logoutIsExpired: false,
};

export default function UserReducer(state = initialState, action: AnyAction) {
    switch (action.type) {
        case USER_LOGIN_START:
            return { ...state, isLoggingIn: true };
        case USER_LOGIN_SUCCESS:
            localStorage.setItem("CRENT_WEB/TOKEN", action.token);
            localStorage.setItem(
                "CRENT_WEB/TOKEN_TTL",
                String(moment.utc().add("24", "hours").format("X")),
            );
            return {
                ...state,
                token: action.token,
                loginIsFailed: false,
            };
        case USER_LOGIN_FAILED:
            return {
                ...state,
                isLoggingIn: false,
                isLoggedIn: false,
                token: null,
                loginIsFailed: true,
            };
        case SET_VIEWER_DATA:
            return {
                ...state,
                viewer: action.data,
                isLoggingIn: false,
                isLoggedIn: true,
            };
        case USER_LOGOUT:
            localStorage.removeItem("CRENT_WEB/TOKEN");
            localStorage.removeItem("CRENT_WEB/TOKEN_TTL");
            return {
                ...state,
                isLoggedIn: false,
                token: null,
            };
        case USER_LOGOUT_EXPIRED:
            return {
                ...state,
                logoutIsExpired: true,
                isLoggedIn: false,
            };

        default:
            return state;
    }
}

export const getState = (state: RootStateOrAny) => {
    if (typeof state.user === "object") {
        return state.user;
    }
    return state;
};

export const selectToken = (state: UserState) => {
    return getState(state).token;
};

export const selectIsLoggedIn = (state: UserState) => {
    return getState(state).isLoggedIn;
};

export const selectIsLoggingIn = (state: UserState) => {
    return getState(state).isLoggingIn;
};

export const selectLoginIsFailed = (state: UserState) => {
    return getState(state).loginIsFailed;
};
